import { OrderFrame } from '@ca/common'
import useCartItems from '@order/hooks/useCart'
import { useOrderState } from '@order/hooks/useOrderState'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { useMemo } from 'react'
import { StockUtils } from './StockUtils'

/**
 * Adjust the frame, with some memoization to avoid recalculating on every item change
 */
export const useAdjustedFrame = (frame: OrderFrame) => {
  const config = useRemoteConfig()
  const stock = useOrderState((state) => state.order.stock)
  const items = useOrderState((state) => state.order.items)
  const { list: cartItems } = useCartItems()

  // Since we don't want to recalculate this on every item change
  //  we only look at items that have this specific frame id
  const relevantItems = useMemo(() => {
    const rel = items.filter((i) => i.frame?.id === frame.id)
    if (rel.length === 0) {
      return undefined
    }
    return rel
  }, [items, frame.id])

  const relevantStock = useMemo(() => {
    if (!relevantItems) {
      return undefined
    }

    return stock
  }, [relevantItems, stock])

  const adjustedFrame = useMemo(() => {
    return StockUtils.adjustStock(
      frame,
      config?.region,
      { stock: relevantStock || {}, items: relevantItems ?? [] },
      cartItems
    )
  }, [frame, config?.region, relevantStock, relevantItems, cartItems])

  return adjustedFrame
}
